import { carouselItems } from '@/mocks/anime';

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热门专题推荐
          </h2>
          <p className="text-foreground-600 text-sm md:text-base max-w-2xl mx-auto">
            精选2026年最受关注的动漫作品，全集高清资源一站下载
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {carouselItems.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/50 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
              </div>
              <div className="p-5">
                <span className="inline-block px-2.5 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full mb-3 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed line-clamp-2">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {carouselItems.slice(3, 5).map((item) => (
            <div
              key={item.id}
              className="group relative rounded-2xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200/50 transition-all duration-300 cursor-pointer flex flex-col md:flex-row"
            >
              <div className="md:w-2/5 aspect-[16/10] md:aspect-auto overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5 md:w-3/5 flex flex-col justify-center">
                <span className="inline-block px-2.5 py-1 bg-accent-100 text-accent-700 text-xs font-medium rounded-full mb-3 whitespace-nowrap self-start">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}